import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { storefrontService } from '../services/storefrontService.js';

const AppDataContext = createContext(null);

export function AppDataProvider({ children }) {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    storefrontService
      .bootstrap()
      .then((payload) => {
        if (!active) return;
        setData(payload);
        setStatus('ready');
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
        setStatus('error');
      });

    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(() => ({ data, status, error, refresh: () => storefrontService.bootstrap().then(setData) }), [data, status, error]);

  return <AppDataContext.Provider value={value}>{children}</AppDataContext.Provider>;
}

export function useAppData() {
  const context = useContext(AppDataContext);
  if (!context) {
    throw new Error('useAppData must be used inside AppDataProvider');
  }

  return context;
}
